import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { errorMessage } from '../api/client';
import { ConnectionBadge } from '../desktop/ConnectionBadge';
import { isDesktop } from '../desktop/bridge';
import { ROLE_LABELS, canAdminister } from '../domain/roles';
import { useCurrentUser, useSession } from '../session/SessionContext';
import { useState } from 'react';
import { LiveBadge } from '../realtime/LiveBadge';
import { Notice } from './Notice';

type Entry = { to: string; label: string };

export function AppLayout() {
  const user = useCurrentUser();
  const { logout } = useSession();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  /**
   * L'import n'a pas d'entrée ici, et c'est délibéré : il suppose un poste
   * choisi, et on vient presque toujours de la fiche de ce poste. Le geste
   * suit donc le contexte — le bouton est sur la fiche, où le poste est déjà
   * connu.
   *
   * La liste des diagnostics reste : elle porte les filtres par type, par date
   * et par plage horaire, et ne fait pas doublon avec la frise d'un poste.
   */
  const entries: Entry[] = [
    { to: '/postes', label: 'Postes' },
    { to: '/diagnostics', label: 'Diagnostics' },
    { to: '/inventaire', label: 'Inventaire' },
  ];
  if (canAdminister(user.role)) {
    entries.push({ to: '/administration/utilisateurs', label: 'Utilisateurs' });
    entries.push({ to: '/administration/salaries', label: 'Salariés' });
  }
  // l'entrée n'existe que dans l'application de bureau : dans le navigateur,
  // il n'y a ni file d'attente ni disque à surveiller
  if (isDesktop()) {
    entries.push({ to: '/hors-ligne', label: 'Hors ligne' });
  }

  const onLogout = (): void => {
    logout()
      .then(() => navigate('/connexion', { replace: true }))
      .catch((cause: unknown) => setError(errorMessage(cause)));
  };

  return (
    <div className="shell">
      <header className="barre">
        {/* la marque ramène à l'écran d'accueil, comme partout ailleurs */}
        <Link to="/postes" className="barre__marque">
          DiagFlow <span>parc informatique</span>
        </Link>
        <nav className="barre__liens">
          {entries.map((entry) => (
            <NavLink
              key={entry.to}
              to={entry.to}
              className={({ isActive }) =>
                isActive ? 'barre__lien barre__lien--actif' : 'barre__lien'
              }
            >
              {entry.label}
            </NavLink>
          ))}
        </nav>
        <div className="barre__compte">
          <LiveBadge />
          <ConnectionBadge />
          <span>
            {user.displayName} · {ROLE_LABELS[user.role]}
          </span>
          <button
            type="button"
            className="bouton bouton--fantome bouton--petit"
            onClick={onLogout}
          >
            Déconnexion
          </button>
        </div>
      </header>
      <main className="contenu">
        {error !== null && (
          <div style={{ marginBottom: 'var(--espace-5)' }}>
            <Notice tone="erreur">{error}</Notice>
          </div>
        )}
        <Outlet />
      </main>
    </div>
  );
}
